import styled from "@emotion/styled";
import classNames from "classnames";
import { type ReactNode } from "react";

import { PanelDragItem } from "@skilitics/designer-ui-components";
import { useDraggable } from "@skilitics/drag-drop";

import { CONDITION_TYPE, EFFECT_TYPE, TYPE_BUILDABLE } from "../constants";
import type { DraggableData } from "./dndSchemas";

interface Props {
  children?: ReactNode;
  conditionOrEffect: typeof CONDITION_TYPE | typeof EFFECT_TYPE;
  typeId: string;
  nodeId: number;
  title: string;
}

export const SidebarDraggable = ({ children, conditionOrEffect, typeId, nodeId, title }: Props) => {
  const { ref, isDragging } = useDraggable({
    id: `${TYPE_BUILDABLE}:${nodeId}:${typeId}`,
    data: {
      rule: {
        type: TYPE_BUILDABLE,
        ruleType: conditionOrEffect,
        typeId,
        nodeId,
      },
      title,
    } satisfies DraggableData,
  });

  return (
    <SidebarDragItem
      ref={ref}
      className={classNames({
        orange: conditionOrEffect === EFFECT_TYPE,
        purple: conditionOrEffect === CONDITION_TYPE,
        disabled: isDragging,
      })}
    >
      {children}
    </SidebarDragItem>
  );
};

const SidebarDragItem = styled(PanelDragItem)`
  margin-bottom: 5px;
`;
